import React from 'react';
import { useQueryClient } from 'react-query';
import { Empty, Modal } from 'antd';
import InnerCard from '../../../../../components/InnerCard/InnerCard';
import Tenant from './Tenant';
import { CardChangeButton } from '../../../../../../../components/Card';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import AddRoomOwnersModal from '../../../../../components/modals/AddRoomOwnersModal/AddRoomOwnersModal';
import useDeleteRoomOwnerMutation from '../../../../../mutations/useDeleteRoomOwnerMutation';
import { roomQueryKeys } from '../../../../../queries/queryKeys';
import { getEditingRoomData } from '../../../../../utils/getEditingRoomData';
import getName from '../../../../../../../helpers/getName';
import commonStyles from '../../../AboutRoom.module.scss';

const { confirm } = Modal;

const Owners = ({ room }) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  const queryClient = useQueryClient();

  const { mutateAsync: deleteOwnerMutateAsync } = useDeleteRoomOwnerMutation({
    onSuccess: () => queryClient.invalidateQueries(roomQueryKeys(room?.id)),
  });

  const handleRemoveBtnClick = (owner) => {
    confirm({
      title: `Удалить собственника ${
        owner.name ? owner.name : getName(owner)
      }?`,
      onOk: async () => {
        const data = getEditingRoomData(room);
        await deleteOwnerMutateAsync({ ownerId: owner.id, room: data });
      },
      onCancel: () => {},
    });
  };

  return (
    <InnerCard
      title="Собственник"
      action={
        <CardChangeButton
          text="Добавить"
          className={commonStyles.innerCardAction}
          onClick={showModal}
        />
      }
    >
      {Boolean(room.landLords?.length) ? (
        room.landLords.map((landLord) => (
          <Tenant
            key={landLord.id}
            tenant={landLord}
            onRemoveBtnClick={handleRemoveBtnClick}
            removeTooltipTitle="Удалить"
          />
        ))
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
      <AddRoomOwnersModal visible={visible} onCancel={hideModal} room={room} />
    </InnerCard>
  );
};

export default Owners;
